import { render } from "./table_create_drawer.vue?vue&type=template&id=63b84790&scoped=true"
import script from "./table_create_drawer.vue?vue&type=script&lang=js"
export * from "./table_create_drawer.vue?vue&type=script&lang=js"

import "./table_create_drawer.vue?vue&type=style&index=0&id=63b84790&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b84790"]])

export default __exports__